// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2fiq9","footer":"ModalUpdate_footer__2_dyO"};